import "zustand/middleware";


function $149c1bd638913645$export$48c17662a6902497() {
    return "BroadcastChannel" in globalThis;
}
function $149c1bd638913645$export$ed80d9de1d9df928(key, api, { ref: ref = "shared-", initialize: initialize = false, serialize: serialize = (v)=>v, unserialize: unserialize = (v)=>v } = {}) {
    const channelName = ref + "-" + key.toString();
    let channel = new BroadcastChannel(channelName);
    let externalUpdate = false;
    let timestamp = 0;
    let cleanup = api.subscribe((state)=>state[key], (state)=>{
        if (!externalUpdate) {
            timestamp = Date.now();
            channel.postMessage({
                timestamp: timestamp,
                state: serialize(state)
            });
        }
        externalUpdate = false;
    });
    channel.onmessage = (evt)=>{
        if (evt.data === undefined) {
            channel.postMessage({
                timestamp: timestamp,
                state: serialize(api.getState()[key])
            });
            return;
        }
        if (evt.data.timestamp <= timestamp) return;
        externalUpdate = true;
        timestamp = evt.data.timestamp;
        api.setState({
            [key]: unserialize(evt.data.state)
        });
    };
    const sync = ()=>channel.postMessage(undefined);
    const unshare = ()=>{
        channel.close();
        cleanup();
    };
    // fetches any available state
    if (initialize) sync();
    return [
        sync,
        unshare
    ];
}


export {$149c1bd638913645$export$48c17662a6902497 as isSupported, $149c1bd638913645$export$ed80d9de1d9df928 as share};
//# sourceMappingURL=index.js.map
